import { c as _c } from "react/compiler-runtime";
import { TooltipCSS } from '@cc-shopping/ui/composites/TooltipCSS';
import { AuthorTooltipContent } from './AuthorTooltipContent';
import type { AuthorHoverTooltipVariantProps } from './types';
type AuthorHoverTooltipProps = Omit<AuthorHoverTooltipVariantProps, 'variant'>;
export const AuthorHoverTooltip = t0 => {
  const $ = _c(12);
  const {
    name,
    bio,
    avatarMiniatureURL,
    socialMediaLinks,
    userPage,
    link,
    children,
    Renderer
  } = t0;
  let t1;
  if ($[0] !== Renderer || $[1] !== avatarMiniatureURL || $[2] !== bio || $[3] !== link || $[4] !== name || $[5] !== socialMediaLinks || $[6] !== userPage) {
    t1 = <AuthorTooltipContent name={name} bio={bio} link={link} avatarMiniatureURL={avatarMiniatureURL} socialMediaLinks={socialMediaLinks} userPage={userPage} Renderer={Renderer} />;
    $[0] = Renderer;
    $[1] = avatarMiniatureURL;
    $[2] = bio;
    $[3] = link;
    $[4] = name;
    $[5] = socialMediaLinks;
    $[6] = userPage;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      sx: {
        border: "1px solid",
        borderColor: "grey.100",
        borderRadius: "20px",
        minWidth: {
          xs: 295,
          sm: 320
        },
        paddingBottom: 2
      },
      id: "author-tooltip",
      "data-testid": "author-tooltip"
    };
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== t1) {
    t3 = <TooltipCSS tooltipContent={t1} tooltipProps={t2}>{children}</TooltipCSS>;
    $[9] = children;
    $[10] = t1;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};